import {
  EXTERNAL_API_LOAD_COLLECTIONS_BEGIN,
  EXTERNAL_API_LOAD_COLLECTIONS_SUCCESS,
  EXTERNAL_API_LOAD_COLLECTIONS_FAILURE,
  EXTERNAL_API_LOAD_COLLECTIONS_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function loadCollections(args = {}) {
  return (dispatch) => {
    dispatch({
      type: EXTERNAL_API_LOAD_COLLECTIONS_BEGIN,
    });
    const { version, projectId } = args;
    const config = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/collections/${projectId}/project`,
        config,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: EXTERNAL_API_LOAD_COLLECTIONS_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: EXTERNAL_API_LOAD_COLLECTIONS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadCollectionsError() {
  return {
    type: EXTERNAL_API_LOAD_COLLECTIONS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EXTERNAL_API_LOAD_COLLECTIONS_BEGIN:
      return {
        ...state,
        loadCollectionsPending: true,
        loadCollectionsError: null,
      };

    case EXTERNAL_API_LOAD_COLLECTIONS_SUCCESS:
      return {
        ...state,
        loadCollectionsPending: false,
        loadCollectionsError: null,
        collections: action.data ? action.data : [],
      };

    case EXTERNAL_API_LOAD_COLLECTIONS_FAILURE:
      return {
        ...state,
        loadCollectionsPending: false,
        loadCollectionsError: action.data.error,
      };

    case EXTERNAL_API_LOAD_COLLECTIONS_DISMISS_ERROR:
      return {
        ...state,
        loadCollectionsError: null,
      };

    default:
      return state;
  }
}
